import { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import LoginPage from './LoginPage';
import VehicleManager from './VehicleManager';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [username, setUsername] = useState('');

    useEffect(() => {
        const storedAuth = sessionStorage.getItem('isAuthenticated');
        const storedUser = sessionStorage.getItem('username');
        if (storedAuth === 'true') {
            setIsAuthenticated(true);
            setUsername(storedUser || '');
        }
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/" element={<LoginPage setIsAuthenticated={setIsAuthenticated} setUsername={setUsername} />} />
                <Route path="/vehicles" element={<VehicleManager isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} username={username} />} />
            </Routes>
             <ToastContainer position="top-right" autoClose={3000} />
        </Router>
    );
}

export default App;
